import React from 'react';

export default function BoxSecondaryUnderline(props) {
  return (
    <div
      id="box-with-secondary-underline"
      className="box-with-secondary-underline"
      style={{ borderBottom: `5px solid ${props.tenant.secondary}` }}
    >
      {props.children}
    </div>
  );
}
